import { UnsafeAction } from '../../interfaces';
import { DepartmentModel } from '../department/department.model';
import { StrippedEmployeeModel } from '../employee/employee.model';
import { SharedModelState } from '../shared.model.state';
import { ShiftModel } from '../shift/shift.model';
import { TeamModel } from '../team/team.model';
import { AbsenceModel } from './../absence/absence.model';
import { AvailabilityModel } from './../availability/availability.model';
import { SkillModel } from './../skill/skill.model';

export interface ScheduleState extends SharedModelState<ScheduleModel> {}

export interface ScheduleBase {
  id?: string;
  team_id: string;
  shift_id: string;
  department_id: string;
  occurrence_id: string;
  date: string;
  starttime: string;
  endtime: string;
  hide_end_time: boolean;
  break: string;
  description: string;
  recurring: boolean;
  repeat_until: string;
  interval: string;
  total: string;
  mo: string;
  tu: string;
  we: string;
  th: string;
  fr: string;
  sa: string;
  su: string;
  created?: string;
  updated?: string;
  created_by?: string;
  modified_by?: string;
  loading?: boolean;
  deleted?: boolean;
  Department?: DepartmentModel;
  Team?: TeamModel;
  Shift?: ShiftModel;
  department_name?: string;
  location_name?: string;
  startDateTime?: Date;
  endDateTime?: Date;
  position?: number;
  canEdit?: boolean;
  canDelete?: boolean;
  conflicts?: ConflictContainer;
  salary?: string;
  coc?: string;
  name?: string;
  hours?: string;
  is_task?: boolean;
  color?: string;
}

export interface ScheduleModel extends ScheduleBase {
  user_id: string;
  custom_fields?: any;
  CreatedBy?: StrippedEmployeeModel;
  ModifiedBy?: StrippedEmployeeModel;
  [propName: string]: any; // allow for custom properties
}

export type ScheduleScope = 'original' | 'occurrence' | 'sequence';

export interface Notify {
  notify: boolean | string;
}

export interface SchedulesLoadRequest {
  userId?: string;
  minDate?: string;
  maxDate?: string;
  departmentId?: string | string[];
}

export enum ShiftType {
  OPEN = 'openShifts',
  REQUIRED = 'requiredShifts',
  SCHEDULED = 'scheduledShifts',
}

export enum ShiftRecurrenceType {
  OCCURRENCE = 'occurrence',
  SEQUENCE = 'sequence',
}

export interface RecurrenceOption {
  value: ShiftRecurrenceType;
  label: string;
}

export interface ScheduleCopyRequest {
  source: {
    startDate: string;
    endDate: string;
  };
  target: {
    startDate: string;
  };
  departmentId: string;
  filters: {
    shiftTypes: ShiftType[];
  };
}

export interface LoadSchedulesSuccessAction extends UnsafeAction {
  requestData: SchedulesLoadRequest;
}

export interface ConflictContainer {
  conflict: boolean;
  availabilities: AvailabilityModel[];
  absences: AbsenceModel[];
  skills: SkillModel[];
  schedules: ScheduleModel[];
}

export interface ScheduleUpdateEvent {
  employeeIds: string[];
  departmentIds: string[];
  occurrenceId?: string;
  teamId?: string;
}
